<template>
    <!--    the parent route has div row and col-12 specified-->
    <np-skeleton v-if="!objectIsNotEmpty(merchant)" :type="'full_view'"></np-skeleton>
    <div v-else>
        <np-application-breadcrumb :crumbs="tabsToRender" :mode="'pagecrumb'"></np-application-breadcrumb>
        <router-view></router-view>
        <div class="row mt-4" style="border-top: 1px solid #b2c6d0">
            <div class="col-12">
                <div class="float-right float-end m-3">
                    <button class="btn btn-danger me-1" @click="backPage"> {{lang('go_back')}}</button>
                    <button class="btn btn-default me-1" @click="nextPage"> {{lang('continue')}}</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { NPSkeleton } from "../../../../js/netpify/components";
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import NPAppBreadcrumb from "../../../components/np-application-breadcrumb.vue";

    export default {
        name: "EquipmentPricingModule",
        mixins:[utilMixin, applicationMixin],
        components: {
            'np-application-breadcrumb': NPAppBreadcrumb,
            'np-skeleton': NPSkeleton,
        },
        data () {
            return {
                equipment_pricing_tabs: [
                    {
                        // class: "btn btn-default",
                        display: true,
                        // icon: "flaticon-cogwheels12",
                        is_active: false,
                        is_open: false,
                        entity_type: 1,
                        short_label: "equipment",
                        label: "tab_equipment_selection",
                        // lang_key: "tab_equipment",
                        tab_id: "tab_equipment",
                        url: "",
                    },
                    {
                        // class: "btn btn-default",
                        display: true,
                        // icon: "flaticon-cogwheels12",
                        is_active: false,
                        is_open: false,
                        entity_type: 1,
                        short_label: "pricing",
                        label: "tab_pricing",
                        // lang_key: "tab_pricing",
                        tab_id: "tab_pricing",
                        url: "pricing",
                    },
                ]
            }
        },
        mounted: function (){
        },
        computed: {
            parameters: function () {
                return this.$parent.parameters;
            },
            tabsToRender: function () {
                let tabs = this.jsonCopy(this.equipment_pricing_tabs);
                tabs.forEach(obj => {
                    obj.url = this.application_root_path + 'products/' + obj.url;
                })

                return tabs;
            }
        },
        methods: {

            backPage: function (){

            },
            nextPage: function () {
                let current_route_index = this.tabsToRender.findIndex(obj => {
                    return obj.url === this.$route.path;
                })

                let next_route = {};

                if (current_route_index < this.tabsToRender.length - 1) {
                    next_route = this.tabsToRender[current_route_index + 1];

                } else {
                }

                this.$router.push({path: next_route.url})
            },
        }

    }
</script>

<style scoped>
</style>
